module.exports = __webpack_public_path__ + "img/iconcp.77306397.png";